import { render, staticRenderFns } from "./MatrixMultipleChoice.vue?vue&type=template&id=824b380a"
import script from "./MatrixMultipleChoice.vue?vue&type=script&lang=js"
export * from "./MatrixMultipleChoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports